const MAX_NUMBER_OF_TRAINING_VISIT = [0, 1, 2];

type MAX_NUMBER_OF_TRAINING_VISIT = typeof MAX_NUMBER_OF_TRAINING_VISIT;

export default MAX_NUMBER_OF_TRAINING_VISIT;
